import { Wizard, WizardProps } from '@/_shared/components/Wizard';
import { INTERNAL_STEPPER } from '@/configuration/constants/stepper';
import { EmployeeConfirmData } from '../EmployeeConfirmData';

type Props = {
  setStepper: (step: number) => void;
};

export const WizardConfiguration = ({ setStepper }: Props) => {
  const wizardSteps: WizardProps['stepsConfig'] = [
    {
      label: '',
      steps: [
        {
          label: 'Employee Confirm Data',
          component: <EmployeeConfirmData />,
          showSkipButton: false,
          forceShowPreviousButton: true,
          onPrevious() {
            setStepper(INTERNAL_STEPPER.START);
          },
        },
      ],
    },
  ];

  return <Wizard stepsConfig={wizardSteps} />;
};
